import React, { useCallback } from 'react';
import { MemoizedDocumentApprovals } from 'components/organisms/document/parts/document-tabs/document-approvals';
import { useApprovalsPaneContext } from 'contexts/approvals-pane';
import { useDocumentApprovalsQuery } from 'queries/document-approvals';

export const CpSpaceTabApprovalsPane: React.FC<{
  documentId: number;
  projectId: number;
}> = ({ documentId, projectId }) => {
  const { data: approvals = [] } = useDocumentApprovalsQuery(
    ['document_id', documentId],
    ['project_id', projectId],
  );
  const { newApprovalData, setNewApprovalData } = useApprovalsPaneContext();

  const onApprovalSubmit = useCallback(() => {
    setNewApprovalData(undefined);
  }, [setNewApprovalData]);

  const onApprovalCancel = useCallback(() => {
    setNewApprovalData(undefined);
  }, [setNewApprovalData]);

  return (
    <MemoizedDocumentApprovals
      isPrivate={false}
      onNewApprovalCancel={onApprovalCancel}
      onNewApprovalSubmit={onApprovalSubmit}
      newData={newApprovalData}
      data={approvals}
      documentId={documentId}
      projectId={projectId}
    />
  );
};
